import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';
import Notify from '@/components/Notification';

export const useUpdateProfilePhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) =>
      userService.updateProfilePhoto(payload).then(response => {
        const { status, data } = response;

        if (status === 200) {
          Notify.success({ text: payload.photo ? 'Photo updated' : 'Photo removed' });
          queryClient.setQueryData([QUERY_KEYS.user.profile], prevData => ({
            ...prevData,
            user: {
              ...prevData.user,
              photo: data.image?.id ? data.image : null,
            },
          }));
          return data;
        }
        return null;
      }),
  });
};
